module.exports = __webpack_public_path__ + "img/filter-icon.5016a4bb.svg";